import styled, { FlattenSimpleInterpolation, css } from 'styled-components'

import { typographyMap } from '~/components/Text/Text.styles'

import { HeightClass } from '~/utils/enum/classes'

import Input, { InputProps } from '../Input'

import { OneTimePasswordProps } from './OneTimePassword.type'

const labeTypographylMap: Record<HeightClass, FlattenSimpleInterpolation> = {
  extraSmall: typographyMap['label-01'],
  small: typographyMap['label-01'],
  semiSmall: typographyMap['label-02'],
  regular: typographyMap['label-02'],
  semiLarge: typographyMap['label-03'],
  large: typographyMap['label-04'],
  extraLarge: typographyMap['label-05'],
  semiGiant: typographyMap['label-06']
}

const requiredLabelTypographylMap: Record<
  HeightClass,
  FlattenSimpleInterpolation
> = {
  extraSmall: typographyMap['label-required-01'],
  small: typographyMap['label-required-01'],
  semiSmall: typographyMap['label-required-02'],
  regular: typographyMap['label-required-02'],
  semiLarge: typographyMap['label-required-03'],
  large: typographyMap['label-required-04'],
  extraLarge: typographyMap['label-required-05'],
  semiGiant: typographyMap['label-required-06']
}

const otpContainerGapTransformer = (
  heightClass: HeightClass
): FlattenSimpleInterpolation => {
  switch (heightClass) {
    case 'large':
    case 'extraLarge':
    case 'semiGiant':
      return css`
        gap: 8px;
      `
    default:
      return css`
        gap: 4px;
      `
  }
}

const otpLabelTransformer = (
  heightClass: HeightClass,
  required?: boolean
): FlattenSimpleInterpolation => {
  if (required) {
    return requiredLabelTypographylMap[heightClass]
  }

  return labeTypographylMap[heightClass]
}

export const InputsContainer = styled.div<
  Pick<OneTimePasswordProps, 'heightClass'>
>`
  display: flex;

  gap: ${({ theme, heightClass }) =>
    theme.oneTimePassword[heightClass]?.spaceBetween}px;

  > div > div {
    width: ${({ theme, heightClass }) =>
      theme.oneTimePassword[heightClass]?.size}px;

    height: ${({ theme, heightClass }) =>
      theme.oneTimePassword[heightClass]?.size}px;

    padding: 0;
  }
`

export const StyledInput = styled(Input)`
  margin: 0;
  text-align: center;
`

export const OTPContainer = styled.div<{ heightClass: HeightClass }>`
  display: flex;
  flex-direction: column;

  ${({ heightClass }) => otpContainerGapTransformer(heightClass)}
`

export const Label = styled.label<Pick<InputProps, 'heightClass' | 'required'>>`
  ${({ heightClass, required }) => otpLabelTransformer(heightClass, required)}
`
